import { Component, Input } from "@angular/core";

@Component({
	selector: "ic-message-warning",
	imports: [],
	templateUrl: "./message-warning.component.html",
	styleUrls: ["./message-warning.component.scss"],
})
export class MessageWarningComponent {
	@Input() message: string;
}
